import styled from 'styled-components';

export const GuestUserWrapper = styled.div`
  width: 100%;  
  max-width: 930px;
  margin: auto;
`;

export const ProfileWrapper = styled.div`
  background: #ffffff;
  margin-bottom: 16px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`;

export const TopHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;

  h1, p {
    margin: 0;
    color: #333333;
  }

  h1 {
    font-size: 30px;
  }

  p {
    color: #00ab6b;
    cursor: pointer;
    font-size: 16px;
  }

  p, .username {
    flex: 1;
  }

  button {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    color: #969696;
    cursor: pointer;
    font-weight: 600;
    padding: 3px 12px;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  
    margin-bottom: 10px;

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 14px;
    }

    button {
      position: absolute;
      right: 0;
      top: 5px;
    }
  }
`;

export const MidleHeader = styled.div`
  p {
    margin: 0;
    color: #969696;
  }
`;

export const BottomHeader = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  margin-top: 4px;

  p {
    margin: 0;
    color: #333333;
    font-weight: 600;
  }

  span {
    color: #969696;
    font-weight: 400;
  }
`;

export const StreamWrapper = styled.div`
  background: #ffffff;
  margin-bottom: 16px;
`;
